function extraireNombre(chaine) {
  var nombre = chaine.match(/\d+/);
  if (nombre !== null) {
    return parseInt(nombre[0], 10);
  } else {
    return 1;
  }
}

var quantity__input = document.getElementById('Quantity-template--22332643803483__main');
var variantes = document.getElementsByClassName('gm-variants-product-p');

// Ajoute les eventListener pour changer la quantité sur les boutons des variantes
for (var i = 0; i < variantes.length; i++) {
  (function(index) {
    var quantity = extraireNombre(variantes[index].textContent);
    if(quantity <= stock){
      variantes[index].addEventListener("click", function() {
        quantity__input.value = quantity;
        quantity__input.dispatchEvent(new Event("change"));
      });
    } else {
      variantes[index].classList.add('gm-out-of-stock');
    }
  })(i);
} 

var price = document.querySelector(".gm-price-container .price-item");

quantity__input.addEventListener("change", () => {
  const prix = price_reductions_by_quantity.filter((ligne) => {
    return ligne.min <= quantity__input.value;
  }).at(-1).price * quantity__input.value;
  const prixFormate = prix.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 });
  
  price.textContent = prixFormate;
});
